import React from "react";
import {
  LegacyCarbonAvoidanceProjectSubType,
  LegacyCarbonAvoidanceProjectType,
  LegacyForestrySubType,
  LegacyRenewablesSubType,
} from "@ecologi/shared";
import CaptureIcon from "@ecologi/assets/icons/ProjectInsights/capture.svg";
import CommunityIcon from "@ecologi/assets/icons/ProjectInsights/community.svg";
import ForestryIcon from "@ecologi/assets/icons/ProjectInsights/forestry.svg";
import RenewablesIcon from "@ecologi/assets/icons/ProjectInsights/renewables.svg";
import TransportIcon from "@ecologi/assets/icons/ProjectInsights/transport.svg";
import WetlandsIcon from "@ecologi/assets/icons/ProjectInsights/wetlands.svg";
import { ProjectVisualsType } from "./project-visuals";

const PATH = "/images/app/forest/carbon_avoidance/pictograms/";

export const carbonAvoidanceVisuals: Record<
  LegacyCarbonAvoidanceProjectType,
  ProjectVisualsType
> = {
  [LegacyCarbonAvoidanceProjectType.Capture]: {
    icon: <CaptureIcon />,
    pictogram: `${PATH}capture.svg`,
  },
  [LegacyCarbonAvoidanceProjectType.Community]: {
    icon: <CommunityIcon />,
    pictogram: `${PATH}community.svg`,
  },
  [LegacyCarbonAvoidanceProjectType.Forestry]: {
    icon: <ForestryIcon />,
    pictogram: `${PATH}forestry.svg`,
  },
  [LegacyCarbonAvoidanceProjectType.Renewables]: {
    icon: <RenewablesIcon />,
    pictogram: "",
  },
  [LegacyCarbonAvoidanceProjectType.Transport]: {
    icon: <TransportIcon />,
    pictogram: `${PATH}transport.svg`,
  },
  [LegacyCarbonAvoidanceProjectType.Wetlands]: {
    icon: <WetlandsIcon />,
    pictogram: `${PATH}wetlands.svg`,
  },
  // Geothermal is waiting on finalised designs and currently shares the renewables icon.
  [LegacyCarbonAvoidanceProjectType.Geothermal]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  [LegacyCarbonAvoidanceProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [LegacyCarbonAvoidanceProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};

export const carbonAvoidanceSubTypeVisuals: Record<
  LegacyCarbonAvoidanceProjectSubType,
  ProjectVisualsType
> = {
  // Biomass, Hydro and Solar are waiting on finalised designs and currently share the renewables icon.
  [LegacyRenewablesSubType.Biomass]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  [LegacyRenewablesSubType.Hydro]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  [LegacyRenewablesSubType.Solar]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  [LegacyRenewablesSubType.Wind]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}wind.svg`,
  },
  [LegacyForestrySubType.ForestProtection]: {
    icon: <ForestryIcon />,
    pictogram: `${PATH}forestry.svg`,
  },
};
